<template>
  <v-row class="ma-0" >
    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-card class="new-card pa-10 elevation-10" align="left">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <template v-if="registeredUsers.length === 0">
          <h2 class="text-center mb-6">すでにアカウント登録が完了しています。</h2>
          <p class="message mb-6">選択いただいた教科・学年では、すでにアカウント登録が完了しています。</p>
          <p class="message mb-6">お手数をおかけしますが、校内の他の先生にアカウント情報をご確認のうえ、下記からログインをお願いいたします。</p>
          <p class="message mb-6">
            ログイン URL：<a :href="loginUrl" target="_blank" rel="noopener noreferrer">{{ loginUrl }}</a>
          </p>
        </template>
        <template v-else>
          <h2 class="text-center mb-6">アカウント登録が完了しました。</h2>
          <p class="message-red mb-6">アカウント情報が記載されたアカウント情報がダウンロードされました。PCのダウンロードフォルダをご確認いただき、Excelファイルが正しくダウンロードされているかご確認ください。</p>
          <p class="message mb-6">
            Excelファイルがダウンロードされていない場合、下記のボタンから、再度ダウンロードをお試しください。
          </p>
          <p class="message-red mb-6">ファイルのダウンロードができない場合は、こちらの画面をスクリーンショットで保存する等、アカウント情報のメモを必ず保存するようお願いいたします。</p>
          <p class="message mb-6">ファイルのダウンロード、または下記アカウント情報の保存が完了しましたら、下記からログインをお願いいたします。</p>
          <div class="text-center mb-4">
            <v-btn color="primary" @click="downloadExcel" :loading="downloading">
              <v-icon left>mdi-file-excel</v-icon>
              アカウント情報ダウンロード
            </v-btn>
          </div>
          <p class="message mb-6">
            ログイン URL：<a :href="loginUrl" target="_blank" rel="noopener noreferrer">{{ loginUrl }}</a>
          </p>
          <v-simple-table class="mb-6">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>パスワード</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in registeredUsers" :key="index">
                  <td>{{ user.login }}</td>
                  <td>{{ user.password }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  data() {
    return {
      downloading: false
    }
  },
  computed: {
    registeredUsers() {
      return this.$store.state.school.registeredUsers
    },
    registeredSchoolId() {
      return this.$store.state.school.registeredSchoolId
    },
    loginUrl() {
      return `${window.location.origin}/sign_in`
    }
  },
  created() {
    if (!this.registeredSchoolId) {
      this.$router.push('/enrollment/auth')
    }
  },
  mounted() {
    if (this.registeredUsers && this.registeredUsers.length > 0) {
      this.downloadExcel()
    }
  },
  methods: {
    async downloadExcel() {
      if (!this.registeredSchoolId) return
      this.downloading = true
      try {
        const userIds = this.registeredUsers.map(u => u.id)
        const res = await this.$axios.get(`/api/v1/schools/${this.registeredSchoolId}/download_accounts`, {
          params: { user_ids: userIds },
          responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: res.data.type })
        const contentDisposition = res.headers['content-disposition']
        let fileName = 'アカウント一覧.xlsx'
        if (contentDisposition) {
          const match = contentDisposition.substring(contentDisposition.indexOf("''") + 2)
          fileName = decodeURI(match).replace(/\+/g, ' ')
        }
        saveAs(blob, fileName)
      } catch (e) {
        this.$toasted.global.error({ message: 'ダウンロードに失敗しました' })
      } finally {
        this.downloading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%

.logo
  margin-right 18px

.new
  &-card
    max-width 1000px

h2
  color #2d5aa3
  font-weight bold
  font-size 22px

.message
  font-size 15px

.message-red
  font-size 15px
  color red
</style>
